import React from "react";

const WagonsCountIcon = ({ color = "#6D7885", ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <rect x="2" y="6" width="8" height="8" rx="1" />
    <rect x="14" y="6" width="8" height="8" rx="1" />
    <path d="M6 6v8m12-8v8m-8-2h4M1 20h22" />
    <circle cx="4" cy="16" r="1.5" />
    <circle cx="8" cy="16" r="1.5" />
    <circle cx="16" cy="16" r="1.5" />
    <circle cx="20" cy="16" r="1.5" />
  </svg>
);

export default WagonsCountIcon;
